import { httpsCallable } from "firebase/functions";
import { functions } from "@/base";

interface GetRelatorioColaboradoresData {
  projetoId: string;
  questionarioId: string;
  licenciadaId: string;
}

interface EmpresaRelatorio {
  id: string;
  nomeFantasia: string;
  cnpj: string;
  responsavel: {
    nome: string;
    email: string;
    telefone: string;
  };
  telefone: string;
  porte: string;
  endereco: {
    estado: string;
    cidade: string;
  };
  nColaboradores: number;
  nRespostas: number;
  habilitada: boolean;
  minimoResposta?: number;
}

export const getRelatorioColaboradores = async (data: GetRelatorioColaboradoresData) => {
  const getRelatorioColaboradoresFunction = httpsCallable<GetRelatorioColaboradoresData, EmpresaRelatorio[]>(
    functions,
    "relatoriosFunctions-getRelatorioColaboradores"
  );
  const result = await getRelatorioColaboradoresFunction(data);
  return result.data;
};
